// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6d58f2be]:export{primaryColor:#ffb81c;secondaryColor:#07a1c1;accentColor:#eb6200}.v-application--wrap h1.display-1[data-v-6d58f2be],.v-application--wrap h2.display-1[data-v-6d58f2be],.v-application--wrap h3.display-1[data-v-6d58f2be]{color:var(--color-secondary);margin-bottom:16px}.v-stepper .v-stepper__header[data-v-6d58f2be]{box-shadow:none}.v-stepper .v-stepper__header .v-stepper__label[data-v-6d58f2be]{text-align:center}", ""]);
// Exports
module.exports = exports;
